export default __webpack_public_path__ + "static/hero-default-b3e62c6c4369ea67ac491f9701d1aaf4.jpg";